/**
 * @param data {Data}
 */
function whenAppStarts(data) {
	thenWaitForDomContentToLoad(data);
}